import { tr } from "@/i18n/copy";
import { Component } from "react";
import { Button } from "@/components/ui/button";

export default class SetupErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="mx-auto grid min-h-screen max-w-xl place-items-center p-6 text-center">
      <section className="space-y-3"><h1 className="font-display text-2xl font-bold">{tr("Configurazione da riprendere")}</h1><p className="text-sm text-muted-foreground">{tr("Non è stato possibile visualizzare un passaggio della configurazione. I dati già salvati restano invariati.")}</p><Button onClick={() => window.location.reload()}>{tr("Riprova")}</Button></section>
    </main>;
  }
}
